import React from "react";

import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar/Sidebar";
import "../css/dashboard.css";

const AdminDashboardPage = () => {
 

  const handleLogout = () => {
    // Clear login state from localStorage
    localStorage.removeItem("isAdminLoggedIn");


    window.location.href = '/admin'; 
  };

  return (
    <div className="admin-dashboard">
      <Sidebar handleLogout={handleLogout}/>
      <div className="main-content">
        
        <Outlet /> 
      </div>
    </div>
  );
};

export default AdminDashboardPage;